export default __webpack_public_path__ + "static/media/pictogramEatingOut64.b147d588.svg";